<template>
	<Autocomplete
		display-name="Zählerart"
		:icon="icon"
		:label="label"
		:name="name"
		endpoint="meter_device_type"
		item-title="description"
		:params="{
			od: 'ASC',
			of: 'description',
			pageSize: 25,
		}"
		data-test="metertypes-autocomplete"
		v-bind="$attrs"
	>
	</Autocomplete>
</template>

<script setup lang="ts">
import Autocomplete from '../Validation/Autocomplete.vue'

defineProps({
	icon: {
		default: 'fa-regular fa-tachometer-alt',
		type: String,
	},
	label: {
		default: 'Zählerart',
		type: String,
	},
	name: {
		default: 'metertypes',
		type: String,
	},
})
</script>

<style scoped></style>
